import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useProductsOpenApi } from 'src/api/db/apiProductsOpen'
import { ProductVariantColor_ } from 'src/api/db/apiProductVariantColor'

export const useProductData = (productId: string | undefined) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [quantityInput, setQuantityInput] = useState(1)

  const { productsByIdsOpen: products } = useProductsOpenApi({
    product_id: productId ? Number(productId) : undefined,
  })

  const product = products?.data?.[0] as any
  const isLoadingProduct = !products && !!productId

  const product_variant = product?.product_variant?.[0]
  const product_variant_colors =
    product_variant?.product_variant_color as ProductVariantColor_[]

  const variantColorId = searchParams.get('variant_color_id')
  const chosen_product_variant_color_ = variantColorId
    ? product_variant_colors?.find((c) => c.id === Number(variantColorId)) ||
      product_variant_colors?.[0]
    : product_variant_colors?.[0]

  const setProduct_variant_color = (color: ProductVariantColor_) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('variant_color_id', color.id.toString())
    setSearchParams(newParams, { replace: true })
  }

  // Set default variant color in URL if not present
  useEffect(() => {
    if (
      product &&
      !variantColorId &&
      chosen_product_variant_color_ &&
      product_variant_colors?.length
    ) {
      const newParams = new URLSearchParams(searchParams)
      newParams.set(
        'variant_color_id',
        chosen_product_variant_color_.id.toString()
      )
      setSearchParams(newParams, { replace: true })
    }
  }, [
    product,
    variantColorId,
    chosen_product_variant_color_,
    product_variant_colors,
    searchParams,
    setSearchParams,
  ])

  // Set quantity to MOQ when product loads
  const moq = product?.moq || 1
  useEffect(() => {
    if (moq) {
      setQuantityInput(moq)
    }
  }, [moq])

  return {
    product,
    isLoadingProduct,
    product_variant_colors,
    chosen_product_variant_color_,
    setProduct_variant_color,
    quantityInput,
    setQuantityInput,
  }
}

